import { useEffect, useState } from "react";
import ArrowRight from "./components/ArrowRight";
import { Link } from "react-router-dom";
import ArrowDownRightWithCircle from "./components/ArrowDownRightWithCircle";

const Homepage = () => {
  const [showTechIdx, setShowTechIdx] = useState(1);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [])
  return (
    <div className="container max-w-7xl mx-auto px-4 md:px-8">
      <section>
        <div className="flex items-center justify-between gap-10 flex-col md:flex-row">
          <div>
            <h1 className="text-3xl font-bold mb-8 lg:text-4xl xl:text-5xl">
              Seamless & Affordable Access to Utility and Supplier Billing and Usage Data
            </h1>
            <p>
              Utility Connect utilizes the latest AI-technology to access and gain real
              time access to customers electricity utility data
            </p>
            {/* <Link to="/demo" className="inline-block">
              <button
                type="button"
                className="bg-gradient-to-b from-cyan-400 to-sky-500 text-white font-medium rounded-md mt-6 px-5 py-3 flex gap-2 items-center shadow-md hover:from-cyan-500 hover:to-sky-600"
              >
                Get Started for Free
                <ArrowRight />
              </button>
            </Link> */}
          </div>
          <img
            src="/images/hero_img.png"
            className="max-w-full md:max-w-[50%] lg:max-w-[45%]"
            alt=""
          />
        </div>
      </section>

      <section className="my-16">
        <h2 className="text-xl font-bold mb-4">
          Perfect solution for any firm that uses utility billing data to support their product,  service or reporting needs
        </h2>
        <div className="rounded-2xl bg-gray-900 px-10 sm:px-16 py-10 gap-16 flex flex-col md:flex-row md:justify-around text-white">
          <div className="w-full md:w-1/4 flex items-center flex-col">
            <img
              src="/images/Accurate.svg"
              className="w-32 h-32"
              alt=""
            />
            <h4 className="font-bold text-lg mb-3 mt-4 whitespace-normal text-center">
              Accurate and Reliable Data
            </h4>
          </div>
          <div className="w-full md:w-1/4 flex items-center flex-col">
            <img
              src="/images/Cost.svg"
              className="w-32 h-32"
              alt=""
            />
            <h4 className="font-bold text-lg mb-3 mt-4 whitespace-normal text-center">
              Cost Effective
            </h4>
          </div>
          <div className="w-full md:w-1/4 flex items-center flex-col">
            <img
              src="/images/Flexible.svg"
              className="w-32 h-32"
              alt=""
            />
            <h4 className="font-bold text-lg mb-3 mt-4 whitespace-normal text-center">
              Flexible – Select the Data You Need
            </h4>
          </div>
          <div className="w-full md:w-1/4 flex items-center flex-col">
            <img
              src="/images/allapi.svg"
              className="w-32 h-32"
              alt=""
            />
            <h4 className="font-bold text-lg mb-3 mt-4 whitespace-normal text-center">
              All API-Driven
            </h4>
          </div>
        </div>


      </section>
      <section className="my-16">
        <div className="flex items-center justify-between gap-10 flex-col md:flex-row">
          <div className="max-w-full md:max-w-[55%]">
            <h2 className="text-2xl font-bold mb-3">
              UtilityConnect’s advanced AI and Computer Vision technology…
            </h2>
            {[
              "Provides Access to Regulated Utilities and Competitive Energy Suppliers Billing Data",
              "Captures Both Residential and C&I Billing Data",
              "Covers All Viable Deregulated Electricity Markets",
              "Continually Adding New Markets, Utilities and Competitive Energy Suppliers"
            ].map((text, index) => (
              <div
                key={index}
                className={`border-b-2 py-3 translation-all duration-200 px-2 flex items-center`}
              // onClick={() => setShowTechIdx(index + 1)}
              >
                <span className="w-2 h-2 bg-gray-600 rounded-full mr-2"></span>
                <p className="text-lg">{text}</p>
              </div>
            ))}
          </div>
          <div className="flex-1">
            {/* <img
              src="/images/tech_img_1.webp"
              className={`w-full ${showTechIdx !== 1 && "hidden"}`}
              alt=""
            /> */}
            <img
              src="/images/tech_img_2.webp"
              className={`w-full}`}
              alt=""
            />
            {/* <img
              src="/images/tech_img_3.webp"
              className={`w-full ${showTechIdx !== 3 && "hidden"}`}
              alt=""
            /> */}
          </div>
        </div>
      </section>
      <section className="my-16">
        <div className="flex items-center justify-between gap-10 flex-col-reverse md:flex-row">
          <div className="flex-1">
            <img
              src="/images/tech_img_3.webp"
              className={`w-full`}
              alt=""
            />
          </div>
          <div className="max-w-full md:max-w-[55%]">
            <h2 className="text-2xl font-bold mb-3">
              What Type of Firms Use UtilityConnect Data?
            </h2>
            {[
              "Competitive Retail Energy Suppliers",
              "Solar and Battery Firms",
              "Energy Consultants and Brokers",
              "Energy Efficiency / Performance Contracting Firms",
              "Demand Response and Curtailment Firms",
              "EPA and Regulatory Energy Program Reporting Firms",
              "Bill Auditing Firms",
              "Commercial Real Estate and Multilocation Businesses",
              "Others"
            ].map((text, index) => (
              <div
                key={index}
                className={`border-b-2 py-3 translation-all duration-200 px-2 flex items-center`}
                onClick={() => setShowTechIdx(index + 1)}
              >
                <span className="w-2 h-2 bg-gray-600 rounded-full mr-2"></span>
                <p className="text-lg">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="w-full text-center">
        <Link to="/demo" className="inline-block">
          <button
            type="button"
            className="bg-gradient-to-b from-cyan-400 to-sky-500 text-white font-medium rounded-md mt-6 px-5 py-3 flex gap-2 items-center shadow-md hover:from-cyan-500 hover:to-sky-600"
          >
            See How It Works
          </button>
        </Link></div>
      {/* <section className="my-16">
        <h2 className="text-2xl text-center font-bold mb-4">
          Frequently Asked Questions
        </h2>
        <div className="max-w-screen-md mx-auto">
          <div className="border-b-2 py-5">
            <h5 className="flex gap-2 items-center text-lg font-bold mb-2">
              <ArrowDownRightWithCircle />
              Is my business and client information secure?
            </h5>
            <p className="font-light leading-6 text-sm">
              Absolutely. We use advanced encryption to protect data during
              transmission and do not store personal information. Your privacy
              and security, as well as your clients', are our top priorities.
            </p>
          </div>
          <div className="border-b-2 py-5">
            <h5 className="flex gap-2 items-center text-lg font-bold mb-2">
              <ArrowDownRightWithCircle />
              What does the analysis involve?
            </h5>
            <p className="font-light leading-6 text-sm">
              Our AI analyzes billing information to ensure timely payments and
              evaluates energy usage patterns. This helps us provide insights
              into your clients' energy habits and reliability.
            </p>
          </div>
          <div className="border-b-2 py-5">
            <h5 className="flex gap-2 items-center text-lg font-bold mb-2">
              <ArrowDownRightWithCircle />
              Will any data be shared with third parties?
            </h5>
            <p className="font-light leading-6 text-sm">
              No, we never share data with third parties without explicit
              consent. We comply with strict privacy policies and all relevant
              data protection regulations.
            </p>
          </div>
          <div className="border-b-2 py-5">
            <h5 className="flex gap-2 items-center text-lg font-bold mb-2">
              <ArrowDownRightWithCircle />
              What kind of report will I receive?
            </h5>
            <p className="font-light leading-6 text-sm">
              You will receive a detailed, personalized report based on your
              clients' billing and usage data, offering insights into payment
              behavior, energy usage, and overall reliability as customers.
            </p>
          </div>
        </div>
        <div className="text-center mt-6">
          <span className="text-gray-500">Have More Questions?</span>
          <a
            href="mailto:Support@eIQdigital.com"
            className="text-sky-500 font-medium underline underline-offset-4 ml-2 hover:text-sky-600"
          >
            Contact Us
          </a>
        </div>
      </section> */}
    </div>
  );
};

export default Homepage;
